var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_10943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1488 5.74268H4.30699C2.7212 5.74268 1.43567 7.02821 1.43567 8.61399V25.8419C1.43567 27.4277 2.7212 28.7132 4.30699 28.7132H30.1488C31.7346 28.7132 33.0202 27.4277 33.0202 25.8419V8.61399C33.0202 7.02821 31.7346 5.74268 30.1488 5.74268Z",
    stroke: "#ffffff",
    strokeWidth: 2.87132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 14.3569H33.0202",
    stroke: "#ffffff",
    strokeWidth: 2.87132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_10943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4558,
    height: 34.4558,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.7800a9be98a4ea645c3cd6fca54b34d5.svg";
export { ForwardRef as ReactComponent };